let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("8o663")]).then(() => parcelRequire('8jFxc'));